import React from "react";
import { ColumnsPhotoAlbum } from "react-photo-album";
import "react-photo-album/columns.css";

const photos = [
  { src: "/images/gallery/photos/1.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/2.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/3.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/4.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/5.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/6.jpeg", width: 4, height: 3 },
  { src: "/images/gallery/photos/7.jpeg", width: 4, height: 3 },
  { src: "/images/gallery/photos/8.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/9.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/10.jpeg", width: 3, height: 4 },
  { src: "/images/gallery/photos/11.jpeg", width: 4, height: 3 },
  { src: "/images/gallery/photos/12.jpeg", width: 4, height: 3 },
];

export default function PhotoGallery() {
  return (
    <section id="gallery">
    <div style={{ padding: 8, maxWidth: 1100, margin: "0 auto" ,   background: "transparent"}}>
      <ColumnsPhotoAlbum
        photos={photos}
        columns={(w) => (w < 600 ? 2 : w < 900 ? 3 : 4)}
        spacing={6}
        renderPhoto={({ imageProps }) => (
          <img
            {...imageProps}
            style={{
              filter: "brightness(0.9)",
              backdropFilter: "blur(4px)",      
              borderRadius: "12px",
              transition: "all 0.3s ease",
            }}
            alt=""
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.75)}
          />
        )}
      />
    </div>
    </section>
  );
}
